import { createTour } from "../../data/repository/tourRepo";

export const createTourUseCase = async (tour) => {
  const response = await createTour(tour);
  return response;
};
